// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Mapre_chat__Chat_command from "./chat_command.js";
import * as Mapre_chat__Chat_tool from "./chat_tool.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Hashtbl from "melange/hashtbl.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function live(events) {
  let _count = Stdlib__List.length(events) - 1000 | 0;
  let _xs = events;
  while (true) {
    const xs = _xs;
    const count = _count;
    if (count <= 0) {
      return xs;
    }
    if (!xs) {
      return /* [] */ 0;
    }
    _xs = xs.tl;
    _count = count - 1 | 0;
    continue;
  };
}

function merge_events(events) {
  const calls = Stdlib__Hashtbl.create(undefined, 32);
  const order = {
    contents: /* [] */ 0
  };
  Stdlib__List.iter((function ($$event) {
    if (!($$event.kind !== "agent_control" && !($$event.kind === "command_result" && $$event.text === ""))) {
      return;
    }
    const tool = $$event.tool;
    if (tool === undefined) {
      order.contents = {
        hd: {
          NAME: "Event",
          VAL: $$event
        },
        tl: order.contents
      };
      return;
    }
    const key_0 = $$event.run_id;
    const key_1 = $$event.source_epoch;
    const key_2 = tool.id;
    const key = [
      key_0,
      key_1,
      key_2
    ];
    const previous = Stdlib__Hashtbl.find_opt(calls, key);
    if (previous !== undefined) {
      const merged = Stdlib__Option.map((function (old) {
        return Mapre_chat__Chat_tool.merge(old, tool);
      }), previous.tool);
      return Stdlib__Hashtbl.replace(calls, key, {
        attachments: previous.attachments,
        seq: previous.seq,
        revision: previous.revision,
        run_id: previous.run_id,
        source_epoch: previous.source_epoch,
        kind: previous.kind,
        text: previous.text,
        truncated: previous.truncated,
        permission_update: previous.permission_update,
        tool: merged,
        command_id: previous.command_id,
        actor: previous.actor
      });
    }
    Stdlib__Hashtbl.add(calls, key, $$event);
    order.contents = {
      hd: {
        NAME: "Tool",
        VAL: key
      },
      tl: order.contents
    };
  }), events);
  return Stdlib__List.rev_map((function (param) {
    if (param.NAME === "Tool") {
      return Stdlib__Hashtbl.find(calls, param.VAL);
    } else {
      return param.VAL;
    }
  }), order.contents);
}

function busy(commands) {
  return Stdlib__List.exists(Mapre_chat__Chat_command.unresolved, commands);
}

function notice_text($$event) {
  if ($$event.kind === "source_gap") {
    return "Stream interrupted; history replayed.";
  } else {
    return $$event.text;
  }
}

function classify($$event) {
  if ($$event.truncated) {
    return "Truncated";
  }
  const match = $$event.kind;
  switch (match) {
    case "agent_thought" :
      return "Thinking";
    case "assistant_message" :
      return "Assistant";
    case "command_result" :
    case "source_gap" :
      return "Notice";
    case "user_message" :
      return "User";
    default:
      if ($$event.tool !== undefined) {
        return "Tool_call";
      } else if ($$event.text !== "") {
        return "Assistant";
      } else {
        return "Skip";
      }
  }
}

function item_of($$event) {
  const base_seq = $$event.seq;
  const base_text = notice_text($$event);
  const base_attachments = $$event.attachments;
  const base_tool = $$event.tool;
  const base_truncated = $$event.truncated;
  const base_actor = $$event.actor;
  const match = classify($$event);
  if (match === "Notice") {
    return {
      id: "e" + String($$event.seq),
      seq: base_seq,
      kind: /* Notice */ 4,
      text: base_text,
      streaming: false,
      delivery: /* Sent */ 0,
      attachments: base_attachments,
      tool: base_tool,
      truncated: base_truncated,
      actor: base_actor
    };
  }
  if (match === "Truncated") {
    return {
      id: "x" + String($$event.seq),
      seq: base_seq,
      kind: /* Notice */ 4,
      text: base_text,
      streaming: false,
      delivery: /* Sent */ 0,
      attachments: base_attachments,
      tool: base_tool,
      truncated: base_truncated,
      actor: base_actor
    };
  }
  if (match === "Assistant") {
    return {
      id: "e" + String($$event.seq),
      seq: base_seq,
      kind: /* Assistant */ 1,
      text: base_text,
      streaming: false,
      delivery: /* Sent */ 0,
      attachments: base_attachments,
      tool: base_tool,
      truncated: base_truncated,
      actor: base_actor
    };
  }
  if (match !== "Tool_call") {
    if (match === "Skip") {
      return;
    } else if (match === "User") {
      return {
        id: "e" + String($$event.seq),
        seq: base_seq,
        kind: /* User */ 0,
        text: base_text,
        streaming: false,
        delivery: /* Sent */ 0,
        attachments: base_attachments,
        tool: base_tool,
        truncated: base_truncated,
        actor: base_actor
      };
    } else {
      return {
        id: "e" + String($$event.seq),
        seq: base_seq,
        kind: /* Thinking */ 2,
        text: base_text,
        streaming: false,
        delivery: /* Sent */ 0,
        attachments: base_attachments,
        tool: base_tool,
        truncated: base_truncated,
        actor: base_actor
      };
    }
  }
  const tool = $$event.tool;
  const key = tool !== undefined ? "t-" + ($$event.run_id + ("-" + ($$event.source_epoch + ("-" + tool.id)))) : "e" + String($$event.seq);
  return {
    id: key,
    seq: base_seq,
    kind: /* Tool_call */ 3,
    text: base_text,
    streaming: false,
    delivery: /* Sent */ 0,
    attachments: base_attachments,
    tool: base_tool,
    truncated: base_truncated,
    actor: base_actor
  };
}

function mark_streaming(items) {
  const last_streamable = function (param) {
    if (!param) {
      return;
    }
    const item = param.hd;
    const found = last_streamable(param.tl);
    if (found !== undefined) {
      return found;
    }
    const match = item.kind;
    switch (match) {
      case /* Assistant */ 1 :
      case /* Thinking */ 2 :
        return item.id;
      default:
        return;
    }
  };
  const id = last_streamable(items);
  if (id !== undefined) {
    return Stdlib__List.map((function (item) {
      if (item.id === id) {
        return {
          id: item.id,
          seq: item.seq,
          kind: item.kind,
          text: item.text,
          streaming: true,
          delivery: item.delivery,
          attachments: item.attachments,
          tool: item.tool,
          truncated: item.truncated,
          actor: item.actor
        };
      } else {
        return item;
      }
    }), items);
  } else {
    return items;
  }
}

function pending_item(command) {
  return {
    id: "c-" + command.id,
    seq: undefined,
    kind: /* User */ 0,
    text: command.text,
    streaming: false,
    delivery: command.state === "uncertain" ? /* Uncertain */ 2 : /* Pending */ 1,
    attachments: command.attachments,
    tool: undefined,
    truncated: false,
    actor: command.actor
  };
}

function local_item(pending) {
  return {
    id: "c-" + pending.id,
    seq: undefined,
    kind: /* User */ 0,
    text: pending.text,
    streaming: false,
    delivery: pending.failed ? /* Uncertain */ 2 : /* Pending */ 1,
    attachments: pending.attachments,
    tool: undefined,
    truncated: false,
    actor: undefined
  };
}

function pending_items(commands) {
  return Stdlib__List.map(pending_item, Stdlib__List.rev(Stdlib__List.filter((function (c) {
    if (c.kind !== "cancel" && !c.in_timeline) {
      if (c.text !== "") {
        return true;
      } else {
        return Caml_obj.caml_notequal(c.attachments, /* [] */ 0);
      }
    } else {
      return false;
    }
  }), commands)));
}

function project(events, commands, pending, param) {
  const items = Stdlib__List.filter_map(item_of, merge_events(events));
  const items$1 = Stdlib__List.exists(Mapre_chat__Chat_command.unresolved, commands) ? mark_streaming(items) : items;
  const table = Stdlib__Hashtbl.create(undefined, 8);
  Stdlib__List.iter((function (e) {
    const id = e.command_id;
    if (id !== undefined && e.kind === "user_message") {
      return Stdlib__Hashtbl.replace(table, id, undefined);
    }
    
  }), events);
  const pending_items$1 = Stdlib__List.filter((function (item) {
    const id = item.id;
    if (id.length > 2 && Stdlib__String.sub(id, 0, 2) === "c-") {
      return !Stdlib__Hashtbl.mem(table, Stdlib__String.sub(id, 2, id.length - 2 | 0));
    } else {
      return true;
    }
  }), pending_items(commands));
  const local = pending !== undefined && !Stdlib__Hashtbl.mem(table, pending.id) && !Stdlib__List.exists((function (c) {
    return c.id === pending.id;
  }), commands) ? ({
      hd: local_item(pending),
      tl: /* [] */ 0
    }) : /* [] */ 0;
  return Stdlib.$at(pending_items$1, Stdlib.$at(items$1, local));
}

export {
  live,
  merge_events,
  busy,
  project,
}
/* Stdlib__Hashtbl Not a pure module */
